import React, { useState } from 'react';
import clsx from 'clsx';
import axios from 'axios'
import { makeStyles } from '@material-ui/styles';
import { AutoCompletePerson, MoneyTypeData, TypePersonData } from './components';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Snackbar from '@material-ui/core/Snackbar';
import MySnackbarContentWrapper from '../../layouts/SnackBars';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  button: {
    margin: theme.spacing(1),
    width: 130,
    textAlign: 'left',
  },
  content: {
    marginTop: theme.spacing(2)
  },
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },

}));

const UsersMoneyTypeData = () => {
  const classes = useStyles();
  const [autotype] = useState('single');

  const [persons, setPersons] = useState({});// return value from child  
  const [moneyTypes, setMoneyTypes] = useState([]); // return value from child
  const [typePersons, setTypePersons] = useState([]); // return value from child

  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage, setSnackMessage] = useState();
  const [snackVariant, setSnackVariant] = useState('success');

  const getPersonValue = Personvalue => {
    setPersons(Personvalue)
  }
  const getMoneyTypeValue = MoneyTypeValue => {
    setMoneyTypes(MoneyTypeValue);
  }
  const getTypePersonValue = TypePersonValue => {
    setTypePersons(TypePersonValue);
  }
  const SaveData = async () => {
    const financeuser = moneyTypes.map(moneyType => ({
      citizen_id: persons.value,
      money_type_id: moneyType,
    }));

    const financetypeperson = typePersons.map(typeperson => ({
      citizen_id: persons.value,
      type_person_id: typeperson,
    }));

    try {
      // add data to eslip_finance_user
      const apiUrl2 = 'https://eslip.snru.ac.th/backend/api/financeUser/deleteData';
      await axios.post(apiUrl2, { citizen_id: persons.value });

      const apiUrl = 'https://eslip.snru.ac.th/backend/api/financeUser/saveMultiData';
      await axios.post(apiUrl, financeuser);
      // add data to eslip_finance_type_person
      const apiUrl3 = 'https://eslip.snru.ac.th/backend/api/financeTypePerson/deleteData';
      await axios.post(apiUrl3, { citizen_id: persons.value });

      const apiUrl4 = 'https://eslip.snru.ac.th/backend/api/financeTypePerson/saveMultiData';
      await axios.post(apiUrl4, financetypeperson);

      setSnackVariant('success');
      setSnackMessage('บันทึกข้อมูลแแล้ว');
      setOpenSnack(true);
    } catch (error) {
      setSnackVariant('error');
      setSnackMessage(error.response.data.error.message)
      setOpenSnack(true);
    }
  }

  const DeleteData = async () => {
    try {
      const apiUrl = 'https://eslip.snru.ac.th/backend/api/financeUser/deleteData';
      const response = await axios.post(apiUrl, { citizen_id: persons.value });

      setSnackVariant('success');
      setSnackMessage(response.data.message);
    } catch (error) {
      setSnackVariant('error');
      setSnackMessage(error.response.data.error.message)
      setOpenSnack(true);
    }
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnack(false);
  };

  return (
    <div className={classes.root} >
      <Grid container spacing={3}>
        <Grid item xs={10}>
          <Paper className={classes.paper}>
            <AutoCompletePerson autotype={autotype} getpersonvalue={getPersonValue} />
          </Paper>
        </Grid>
        <Grid item xs>
          <Paper className={classes.paper}>
            <Button variant="contained" className={classes.button} color="primary" onClick={SaveData}>
              <SaveIcon className={clsx(classes.leftIcon, classes.iconSmall)} />บันทึกข้อมูล
            </Button>
            <Button variant="contained" className={classes.button} color="default" onClick={DeleteData}>
              <DeleteIcon className={clsx(classes.leftIcon, classes.iconSmall)} />ลบข้อมูล
            </Button>
          </Paper>
        </Grid>
      </Grid>
      <div className={classes.content}>
        <Paper className={classes.paper}>
          <TypePersonData financeuser={persons} getTypePersonValue={getTypePersonValue} />
        </Paper>
        <Paper className={classes.paper}>
          <MoneyTypeData financeuser={persons} getMoneyTypeValue={getMoneyTypeValue} />
        </Paper>

      </div>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <MySnackbarContentWrapper
          onClose={handleClose}
          variant={snackVariant}
          message={snackMessage}
        />
      </Snackbar>
    </div>
  );
};

export default UsersMoneyTypeData;
